import {EffectType} from "@/store/artifact/types";

export interface ConsumableState {
}


export class ConsumableInfo {
    consumableType!: ConsumableType;
    effectType!: EffectType;
    effectValue!: number;
    consumableId!: number;
    imageId!: string;
    description!: string;
    name!: string;
}

export class Consumable {
    consumableId!: number;
    imageId!: string;
    name!: string;
    effectType!: EffectType;
    consumableType!: ConsumableType;
    effectValue!: number;
    description!: string;
    id!: number;
}

export class ConsumableWithCount {
    consumableId!: number;
    imageId!: string;
    name!: string;
    effectType!: EffectType;
    consumableType!: ConsumableType;
    effectValue!: number;
    description!: string;
    count!: number;
}

export class ConsumableSetting {
    consumableType: ConsumableType | undefined;
    effectType: EffectType | undefined;
    effectCategory: EffectCategory | undefined;
}

export enum ConsumableType {
    ENEMY = 'ENEMY',
    PLAYER = 'PLAYER',
}

export enum EffectCategory {
    STRONGEST = 'STRONGEST',
    WEAKEST = 'WEAKEST',
    ANY = 'ANY'
}
